import { zodResolver } from '@hookform/resolvers/zod'
import { useSearch } from '@tanstack/react-router'
import { trpc } from '@viastud/ui/lib/trpc'
import { grade } from '@viastud/utils'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
const freeUserRegistrationSchema = z.object({
  lastName: z.string().min(1, {
    message: 'Le nom est requis',
  }),
  firstName: z.string().min(1, {
    message: 'Le prénom est requis',
  }),
  phoneNumber: z.string().min(1, {
    message: 'Le téléphone est requis',
  }),
  grade: z.enum(grade),
  utmSource: z.string().optional(),
})

type FreeUserRegistration = z.infer<typeof freeUserRegistrationSchema>

// Déclarations globales pour GA4 et Meta Pixel
declare global {
  function gtag(...args: unknown[]): void
  function fbq(...args: unknown[]): void
}

export function useFreeRegistrationPresenter() {
  const [success, setSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [error, setError] = useState<boolean>(false)

  const mutation = trpc.user.registerFreeUser.useMutation({
    onSuccess: () => {
      setErrorMessage(null)
      setSuccess(true)

      // Tracking GA4 : événement Lead
      if (typeof gtag !== 'undefined') {
        gtag('event', 'lead', {
          event_category: 'form',
          event_label: 'registration_form',
          value: 1,
        })
      }

      // Tracking Meta Pixel : événement Lead
      if (typeof fbq !== 'undefined') {
        fbq('track', 'Lead', {}, { eventID: `lead-${Date.now()}` })
      }
    },
    onError: (e) => {
      if (e.data?.code === 'BAD_REQUEST' && e.message.includes('existe déjà')) {
        setErrorMessage("L'adresse mail est déjà utilisée")
      } else {
        setErrorMessage("Erreur lors de l'inscription gratuite")
      }
    },
  })

  const search: { utm_source?: string } = useSearch({ from: '/checkout' })

  const getDefaultValues = (): FreeUserRegistration => ({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    grade: 'TROISIEME',
    utmSource: search?.utm_source ?? '',
  })

  const checkoutForm = useForm<FreeUserRegistration>({
    resolver: zodResolver(freeUserRegistrationSchema),
    defaultValues: getDefaultValues(),
  })

  const handleFreeRegistration = (data: FreeUserRegistration) => {
    mutation.mutate({
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      grade: data.grade,
      utmSource: data.utmSource,
    })
  }

  return {
    freeRegistrationError: errorMessage,
    setError,
    error,
    handleFreeRegistration,
    success,
    checkoutForm,
  }
}
